<button class="di-product-dropdown" [matMenuTriggerFor]="products">
  <span class="material-symbols-outlined">domain</span>
  {{ isMenuLoading ? 'Loading...' : 'Web Portal' }}
</button>
<mat-menu #products="matMenu" class="product-dropdown-wrapper">
  <div (click)="$event.stopPropagation()" class="category-wrapper" *ngFor="let item of datiumProducts">
    <h5>{{ item.category }}</h5>
    <button *ngFor="let product of item.products" (click)="redirect(product.url)" mat-menu-item>
      <span class="material-symbols-outlined">{{product.icon}}</span>
      {{ product.name }}
    </button>
  </div>
  <div (click)="$event.stopPropagation()" class="category-wrapper">
    <h5>WEB PORTAL</h5>
    <button (click)="redirect('/')" class="active" mat-menu-item>
      <span class="material-symbols-outlined">domain</span>
      Web Portal Home
    </button>
  </div>
</mat-menu>